import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { PatchesName } from '../helpers/types';

export const PrivateRouters = () => {
  const { jwt } = useLocalStorage();
  // console.log(jwt)
  return jwt ? <Outlet /> : <Navigate to={`/${PatchesName.Login}`} />;
};
